import { render } from "./Organisation.vue?vue&type=template&id=8a8a0c3c&scoped=true"
import script from "./Organisation.vue?vue&type=script&lang=js"
export * from "./Organisation.vue?vue&type=script&lang=js"

import "./Organisation.vue?vue&type=style&index=0&id=8a8a0c3c&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8a0c3c"]])

export default __exports__